import React, { Component } from 'react';

import AuthStore from 'data/auth';
import storeConnect from 'data/store-connect';

import { Route, Redirect } from 'react-router-dom';

const storeMap = {
  isAuthenticated: () => AuthStore.isAuthenticated()
};

@storeConnect(storeMap, [AuthStore])
class AuthRoute extends Component {
  get redirectUrl() {
    return encodeURIComponent(this.props.location.pathname + this.props.location.search);
  }
  render() {
    const { isAuthenticated, component: Component, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: '/login/?r=' + this.redirectUrl,
                state: { from: props.location }
              }}
            />
          )
        }
      />
    );
  }
}

export default AuthRoute;
